import React from 'react';
import Footer from 'shared/components/footer/Footer';
import './results.css';
import {
  Alert,
  ButtonLink,
  Card,
  CardGrid,
  FunnelPage,
  FunnelSection,
  Hero,
  ProofMedia,
  SectionHeader,
  StatCard,
} from 'shared/components/funnel/FunnelUI';

const reports = [
  {
    month: 'October',
    pnl: '+2452.87%',
    image: '/assets/images/results/result1.png',
    pdf: '/assets/pdf/OCTOBER2024.pdf',
  },
  {
    month: 'November',
    pnl: '+9952.5%',
    image: '/assets/images/results/result2.png',
    pdf: '/assets/pdf/NOVEMBER2024.pdf',
  },
  {
    month: 'December',
    pnl: '+26129.79%',
    image: '/assets/images/results/result3.png',
    pdf: '/assets/pdf/DECEMBER2024.pdf',
  },
];

function Results() {
  const handleDownload = (pdfPath) => {
    const link = document.createElement('a');
    link.href = pdfPath;
    link.download = pdfPath.split('/').pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <FunnelPage className="results-page">
      <Hero
        eyebrow="Historical report archive"
        title="VIP Group Results"
        copy="The monthly PDF archive is preserved with the same filenames. Treat every report as historical documentation, not a forecast."
        actions={
          <>
            <ButtonLink to="/services/vip">View VIP</ButtonLink>
            <ButtonLink href="https://t.me/cryptoxnfts" variant="secondary">Free Telegram</ButtonLink>
          </>
        }
        stats={
          <>
            <StatCard value="3 PDFs" label="Reports preserved" note="October, November, December" />
            <StatCard value="Historical" label="Proof archive" note="No guarantee" />
            <StatCard value="Manual" label="Download buttons" note="Same filenames" />
          </>
        }
        media={
          <div className="results-hero-media">
            <ProofMedia src="/assets/images/results/result1.png" alt="October results preview" label="October report" />
            <ProofMedia src="/assets/images/results/result2.png" alt="November results preview" label="November report" />
          </div>
        }
      />

      <FunnelSection tone="muted">
        <SectionHeader
          eyebrow="Downloads"
          title="Monthly PDF reports."
          copy="Download buttons intentionally keep the exact public filenames used by the existing site."
        />
        <CardGrid columns={3} className="results-report-grid">
          {reports.map((report) => (
            <Card key={report.month} title={report.month} copy="Historical VIP results PDF.">
              <ProofMedia src={report.image} alt={`${report.month} result preview`} label={`PNL: ${report.pnl}`} />
              <ButtonLink onClick={() => handleDownload(report.pdf)} variant="secondary">
                Download PDF
              </ButtonLink>
            </Card>
          ))}
        </CardGrid>
      </FunnelSection>

      <FunnelSection>
        <div className="results-final-grid">
          <SectionHeader
            align="start"
            eyebrow="Context"
            title="Proof should support diligence, not shortcut it."
            copy="Use reports to understand the historical style of the VIP flow. Continue to VIP only after reviewing the offer and risk disclosure."
          />
          <Alert tone="warning">
            Past PNL, screenshots, and PDF reports do not guarantee future performance. Crypto trading can result in partial or total loss.
          </Alert>
        </div>
      </FunnelSection>

      <Footer />
    </FunnelPage>
  );
}

export default Results;
